module.exports = __webpack_public_path__ + "static/img/top_bg_qt.3a372c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/top_bg_qt.png
// module id = 1101
// module chunks = 1